import PropTypes from 'prop-types';
import React from 'react';
// External Imports
import Helmet from 'react-helmet';
import sanitizeHtml from 'sanitize-html';

// Internal Imports
import { plainTextNoHTML } from '../../config/sanitizeHtml.mjs';

//  Search engines should not show a cached link to the page on a SERP.
const metaRobotsNoarchive = <meta content="noarchive" name="robots" />;

// Component Definition
function Meta({ metaTags, title }) {
  const metaTitle = metaTags.find((tag) => tag.name === 'title');
  const metaTitleContent = metaTitle && metaTitle.content;
  let containsRobots = false;

  return (
    <Helmet>
      <title>{metaTitleContent || title}</title>
      {metaTags.map(({ content, name }) => {
        // Special exception for OpenGraph tags improperly using the property attribute instead of name
        let updatedContent = content;
        if (name === 'robots') {
          // If content field does not contain archive or noarchive, add noarchive
          if (updatedContent.search('archive') === -1) {
            updatedContent = `${content}, noarchive`;
          }
          containsRobots = true;
        }

        if (name === 'is_live_specific' && content === true) {
          return <meta content="live" key={name} name="product_category" />;
        }

        return /^(?:og|fb):/.test(name) ? (
          <meta
            content={sanitizeHtml(updatedContent, plainTextNoHTML)}
            key={name}
            property={name}
          />
        ) : (
          <meta content={sanitizeHtml(updatedContent, plainTextNoHTML)} key={name} name={name} />
        );
      })}
      {containsRobots ? undefined : metaRobotsNoarchive}
    </Helmet>
  );
}

Meta.propTypes = {
  metaTags: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
};

Meta.defaultProps = {
  metaTags: [],
  title: 'Babbel Magazine',
};

// Module Exports
export { Meta };
